// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Money48Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Money48: FC<Money48Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="M22.55 42v-4.2c-1.9-.333-3.458-1.058-4.675-2.175-1.217-1.117-2.092-2.525-2.625-4.225l2.8-1.15c.567 1.6 1.383 2.792 2.45 3.575 1.067.783 2.35 1.175 3.85 1.175 1.6 0 2.917-.4 3.95-1.2 1.033-.8 1.55-1.9 1.55-3.3 0-1.467-.458-2.6-1.375-3.4-.917-.8-2.642-1.617-5.175-2.45-2.4-.767-4.192-1.783-5.375-3.05-1.183-1.267-1.775-2.85-1.775-4.75 0-1.833.592-3.367 1.775-4.6 1.183-1.233 2.725-1.933 4.625-2.1V6h3v4.15c1.5.167 2.792.658 3.875 1.475A7.868 7.868 0 0 1 31.9 14.75l-2.8 1.2c-.467-1.067-1.092-1.842-1.875-2.325-.783-.483-1.808-.725-3.075-.725-1.533 0-2.75.35-3.65 1.05-.9.7-1.35 1.65-1.35 2.85 0 1.267.5 2.292 1.5 3.075 1 .783 2.85 1.592 5.55 2.425 2.267.7 3.942 1.708 5.025 3.025 1.083 1.317 1.625 2.975 1.625 4.975 0 2.1-.617 3.792-1.85 5.075-1.233 1.283-3.05 2.108-5.45 2.475V42h-3Z" />
        </svg>
    );
};

export default Money48;
